var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReviewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0368 0L12.1093 5.48437L18.0736 6.82813L14.007 11.5597L14.6215 17.8747L9.0368 15.3155L3.45206 17.8747L4.06656 11.5597L0 6.82813L5.96429 5.48437L9.0368 0Z",
    fill: "#FFA726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviewStar);
export default __webpack_public_path__ + "static/media/icon-review-star.db49760f940245ccac2c459f59b53a0e.svg";
export { ForwardRef as ReactComponent };